import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Fade from '@mui/material/Fade';

function UpperNavbar({ data }) {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

 const photo = data?.educationDetails?.photo;

const imgUrl = photo
  ? photo.startsWith("https://aicee.s3.ap-south-1.amazonaws.com/")
    ? photo.replace(
        "https://aicee.s3.ap-south-1.amazonaws.com/",
        "https://docs.aicee.in/"
      )
    : photo
  : "https://docs.aicee.in/aicee-dummy-avatar-dashboard.png";

  return (
    <div
      className="flex items-center justify-between flex-row-reverse px-4 sm:px-6 md:px-10"
      style={{
        height: '3.2rem',
        backgroundColor: 'white',
        boxShadow:
          'rgba(14, 30, 37, 0.12) 0px 2px 4px 0px, rgba(14, 30, 37, 0.32) 0px 2px 16px 0px',
      }}
    >
      {/* Right section: Welcome + Avatar */}
      <div
        className="flex items-center justify-center pl-4 pr-4 sm:pl-6 sm:pr-6"
        style={{
          borderLeft: '1px solid #E5E5E5',
          borderRight: '1px solid #E5E5E5',
          height: '100%',
          marginRight: '1rem',
        }}
      >
        <Button
          id="fade-button"
          aria-controls={open ? 'fade-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
          onClick={handleClick}
          className="flex items-center gap-2 max-w-[150px] sm:max-w-[200px] md:max-w-[250px] overflow-hidden whitespace-nowrap justify-start"
          style={{ textTransform: 'capitalize' }}
        >
          <span
            className="text-black truncate w-full text-sm sm:text-base text-left"
          >
            {data?.name || ''}
          </span>
          <img
            className="w-[30px] h-[30px] sm:w-[35px] sm:h-[35px] rounded-full border border-gray-300 object-cover shrink-0"
            src={imgUrl}
            alt="avatar"
          />
        </Button>

        <Menu
          id="fade-menu"
          MenuListProps={{
            'aria-labelledby': 'fade-button',
          }}
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          TransitionComponent={Fade}
        >
          <MenuItem onClick={() => navigate('/student-dashboard')}>Dashboard</MenuItem>
          <MenuItem onClick={() => navigate('/my-profile')}>Profile</MenuItem>
          <MenuItem onClick={() => navigate('/change-password')}>Change Password</MenuItem>
          <MenuItem onClick={() => navigate('/logout')}>Logout</MenuItem>
        </Menu>
      </div>

      {/* Left section: Logo */}
      <div className="flex items-center shrink-0">
        <img
          className="w-24 sm:w-32 md:w-40 lg:w-48 object-contain"
          style={{ padding: '0.5rem 0' }}
          src="https://ucarecdn.com/c048ae5b-1a85-481d-9ba1-0dfb344701af/AICEE2023LOGOPNG.png"
          alt="logo"
        />
      </div>
    </div>
  );
}

export default UpperNavbar;
